'use client'

const INDUSTRY_TAG_COLORS: Record<string, { bg: string; text: string }> = {
  '企业服务(SaaS)': { bg: 'bg-blue-50', text: 'text-blue-700' },
  '政务服务': { bg: 'bg-purple-50', text: 'text-purple-700' },
  '生活服务': { bg: 'bg-green-50', text: 'text-green-700' },
  '人工智能': { bg: 'bg-blue-50', text: 'text-blue-700' },
  '物联网': { bg: 'bg-teal-50', text: 'text-teal-700' },
  '工业互联网': { bg: 'bg-cyan-50', text: 'text-cyan-700' },
  '内容平台': { bg: 'bg-pink-50', text: 'text-pink-700' },
  '在线教育': { bg: 'bg-indigo-50', text: 'text-indigo-700' },
  '企业内部管理': { bg: 'bg-gray-50', text: 'text-gray-700' },
  '物流仓储': { bg: 'bg-amber-50', text: 'text-amber-700' },
  '汽车': { bg: 'bg-red-50', text: 'text-red-700' },
  '金融': { bg: 'bg-indigo-50', text: 'text-indigo-700' },
  '医疗健康': { bg: 'bg-red-50', text: 'text-red-700' },
  '零售/新消费': { bg: 'bg-emerald-50', text: 'text-emerald-700' }
}

interface IndustryTagProps {
  tag: string
}

export function IndustryTag({ tag }: IndustryTagProps) {
  const colors = INDUSTRY_TAG_COLORS[tag] || { bg: 'bg-gray-50', text: 'text-gray-700' }

  return (
    <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded ${colors.bg} ${colors.text}`}>
      {tag}
    </span>
  )
}
